import React from "react";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useAuth } from "../../contexts/auth";

const GridCard = ({
    data,
    viewHandler,
    editHandler,
    deleteHandler,
    isEditable = false,
}) => {
    return (
        <div
            className="bg-white rounded-lg overflow-hidden cursor-pointer shadow-[0px_0px_11px_0px_#e8442d]"
            onClick={isEditable ? () => { } : () => viewHandler(data._id)}
        >
            <div className="flex flex-col justify-between p-4 border-b-[1px] border-[#e8432d53]">
                <div className="flex flex-col justify-center items-center w-[100%]">
                    <img
                        src={`${process.env.BACKEND_URL}files/${data.cell_image}?thumb=1`}
                        alt="cellImage"
                        className="w-20 h-20"
                    />
                </div>
                {data.battery_id &&
                    <div className="mb-2 flex flex-row justify-center items-center w-[100%]">
                        <img
                            src={`${process.env.BACKEND_URL}files/barcode/${data.battery_id}`}
                            alt="barcode"
                            className="w-20"
                        />
                    </div>
                }
            </div>
            <div className="p-4">
                <div className="text-gray-700 mb-2">
                    <b>Manufacturer:</b> {data.meta ? data.meta.manufacturer : data.manufacturer}
                </div>
                <div className="text-gray-700 mb-2">
                    <b>Cell Voltage:</b> {data.electrical_properties ? data.electrical_properties.nominal_voltage : data.nominal_voltage}
                </div>
                <div className="text-gray-700 mb-2">
                    <b>Cell Capacity:</b> {data.electrical_properties ? data.electrical_properties.capacity : data.capacity}
                </div>
                {data.soh && <div className="text-gray-700 mb-2"><b>SoH:</b> { data.soh }</div>}
                <div className="text-gray-700 mb-2"><b>Price:</b> {data.meta ? data.meta.price:data.price}</div>
                {data.count && <div className="text-gray-700 mb-2"><b>Quantity:</b> {data.count}</div>}
                {data.model && <div className="text-gray-700 mb-2"><b>Model:</b> {data.model}</div>}
                {isEditable && (
                    <div className="flex mt-3 felx-row justify-center gap-8 shadow-[0px_0px_5px_0px_#e8442d] rounded-md p-2">
                        <Visibility
                            cursor="pointer"
                            onClick={() => viewHandler(data._id)}
                        >
                            Show Details
                        </Visibility>
                        <Edit
                            color="info"
                            cursor="pointer"
                            onClick={() => editHandler(data._id)}
                        >
                            Edit
                        </Edit>
                        <Delete
                            color="error"
                            cursor="pointer"
                            onClick={() => { deleteHandler(data._id); }}
                        >
                            Delete
                        </Delete>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GridCard;
